import $ from 'jquery';
import errorResponseHandler from './errorResponseHandler';
import contextData from '../contextData';

function AnonymousRepositoryHelper() {

  var self = this;

  /**
   * Returns a promise for an anonymous GET AJAX request
   * @param {string} url
   * @return {Promise}
   */
  self.ajaxGet = function (url) {
    return new Promise(function (resolve, reject) {
      $.ajax(createAjaxSetting(url)).then(resolve, function (jqXhr) {
        errorResponseHandler.handleErrorResponse(jqXhr);
        reject(jqXhr);
      });
    });
  };

  /**
   * Returns a promise for an anonymous POST AJAX request. Post should be used to create a new resource
   * @param {string} url
   * @param {*} data JavaScript object
   * @return {Promise}
   */
  self.ajaxPost = function (url, data) {

    return new Promise(function (resolve, reject) {
      $.ajax(createAjaxSetting(url, 'POST', data)).then(resolve, function (jqXhr) {
        errorResponseHandler.handleErrorResponse(jqXhr);
        reject(jqXhr);
      });
    });
  };

  /**
   * Creates an jQuery AJAX setting object for the given parameters to execute and anonymous request
   * @param {string} url
   * @param {string} [type]
   * @param {*} [data]
   * @return {*}
   */
  function createAjaxSetting(url, type, data) {

    var languageCode = contextData.languageCode();

    var settings = {
      url: url,
      type: type || 'GET',
      dataType: 'json'
    };

    // If the user has changed the language then set the language code to override the default browser language
    if (languageCode) {
      settings.headers = {
        'Accept-Language': languageCode
      };
    }

    if (data) {
      settings.data = JSON.stringify(data);
      settings.contentType = 'application/json';
    }

    return settings;
  }
}

export default new AnonymousRepositoryHelper();
